export function stripStoryblokPathPrefix(path: string, country: string, language?: string): string | null {
    const segments = path.replace(/^\/+|\/+$/g, '').split('/');

    if (language && segments[0] === language && segments[1] === country) {
        return segments.slice(2).join('/');
    }

    if (segments[0] === country) {
        return segments.slice(1).join('/');
    }

    return null;
}
